import { BehaviorSubject } from 'rxjs';

const addressServicabillitySideSheetSubject = new BehaviorSubject({
  isOpen: false,
  savedAddress: {},
  savedAddressLine: '',
});

export const AddressServicabillitySideSheet = {
  update: value => {
    addressServicabillitySideSheetSubject.next(value);
  },
  subscribe: setState => addressServicabillitySideSheetSubject.subscribe(setState),
  getValue: () => addressServicabillitySideSheetSubject.value,
  open: () => {
    addressServicabillitySideSheetSubject.next({ ...addressServicabillitySideSheetSubject.value, isOpen: true });
  },
  close: () => {
    addressServicabillitySideSheetSubject.next({ ...addressServicabillitySideSheetSubject.value, isOpen: false });
  },
};
